import Type from './type';
import getDom from './getDom';
export default async function domDecorator(decorator, parentSelector = '') {
  for (const selector in decorator) {
    const element = decorator[selector];
    if (Type.isString(element)) {
      // 根节点
      const dom = await getDom(parentSelector);
      if (dom) {
        const target = $(parentSelector);
        if (selector == 'text') {
          target.html(element);
          // console.log(`设置 ${parentSelector} 的内容为 ${element}`);
        } else {
          target.attr(selector, element);
          // console.log(`设置 ${parentSelector} 的属性${selector}为 ${element}`);
        }
      }
    } else {
      domDecorator(element, parentSelector + ' ' + selector);
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/domDecorator.js